import get from 'lodash.get';
import actionTypes from '../../user/constants/action-types';
import wonderchat from '../wonderchat';
import serviceClient from '../../feature-flags/service-client';
import setIntegration from '../actions/set-integration';
import integrationTypes from '../constants/integration-types';
import initializeZendesk from '../zendesk/initializers/initialize-zendesk';

const initHelpCenter = (store) => (next) => (action) => {
  const { type, payload } = action;

  next(action);

  if (type !== actionTypes.SET_PARTNER_DATA) {
    return;
  }

  const isWL = get(payload, 'partnerData.isWhiteLabel', true);

  if (!isWL) {
    const featureFlagsManager = serviceClient.get();

    featureFlagsManager.request(['zendesk_widget', 'wonderchat_widget']).then((flags) => {
      const { wonderchat_widget: wonderchatWidget, zendesk_widget: zendeskWidget } = flags;

      if (wonderchatWidget) {
        store.dispatch(setIntegration(integrationTypes.WONDERCHAT));
        wonderchat.initChat();
      } else if (zendeskWidget) {
        store.dispatch(setIntegration(integrationTypes.ZENDESK));
        initializeZendesk(store);
      }
    });
  }
};

export default initHelpCenter;
